import type { IconProps } from '../types/IconProps.ts';
export const MapPinned: IconProps = {
    name: 'MapPinned',
    children: [
        `<path d="m12.04 12.94 3.2-5.03a3.84 3.84 0 1 0-6.48 0l3.2 5.03q.04.04.08 0" />`,
        `<circle cx="12" cy="5.5" r=".5" />`,
        `<path d="m3 21 5.19-1.78a2 2 0 0 1 1.27-.01l4.83 1.59a2 2 0 0 0 1.25 0L21 19M21 11v8M3 14v7M9 11v8M15 14v6M9 10.5 3 14M13 12.5l1.19.82a2 2 0 0 0 2.05.13L21 11" />`,
    ]
};